import axios from "axios";
import * as constant from '../global/const';

export const TOKEN_AZURE = "token";
export const USUARIO = "usuario";
export const KEY_CARRITO = constant.CARRITO;
export const KEY_CARRITOPROMOS = constant.CARRITOPROMO;
export const SUCURSAL = 'sucursal'
export const NOTIFICACIONES = 'notificaciones'


const Auth = {

    //salir
    signOut() {
        localStorage.removeItem(TOKEN_AZURE)
        localStorage.removeItem(USUARIO)
        localStorage.removeItem(SUCURSAL)
        localStorage.removeItem(NOTIFICACIONES)
        this.deleteCarrito()
    },

    //token
    setToken(token) {
        return localStorage.setItem(TOKEN_AZURE, token);
    },
    getToken() {
        return localStorage.getItem(TOKEN_AZURE);
    },

    //user
    setUsuario(usuario) {
        return localStorage.setItem(USUARIO, usuario);
    },
    getUsuario() {
        return localStorage.getItem(USUARIO);
    },

    //carrito
    deleteCarrito(){
        localStorage.removeItem(KEY_CARRITO)
        localStorage.removeItem(KEY_CARRITOPROMOS)
    },

    headerToken() {
        axios.interceptors.request.use(function(config) {
            const token = localStorage.getItem(TOKEN_AZURE);
            if ( token != null ) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            config.headers['Ocp-Apim-Subscription-Key'] = `${process.env.REACT_APP_SUBCRIPTION_KEY}`
            config.headers['Access-Control-Allow-Origin'] = '*'
            return config;
        }, function(err) {
            return Promise.reject(err);
        });
    },

    ValidateExp(){
        var exp = localStorage.getItem('exp');
        var fechaActual = new Date();
        fechaActual = fechaActual.toString()
        if(Date.parse(fechaActual) >= Date.parse(exp)){
            this.signOut();
        }else{
        }
    }

}

export default Auth
